export default "__VITE_ASSET__C134kB1K__"